import { loadStripe, Stripe } from '@stripe/stripe-js';
import { appConfig } from '../appConfig';

// Stripe.js otherwise uses the account's default API version (2017-08-15), under which a
// PaymentIntent reports `requires_source_action` and `requires_source` instead of the
// `requires_action` and `requires_payment_method` statuses the sagas check for. Pinned to the
// same version as the tenancy API (apps/tenancy/src/modules/stripe/stripe.module.ts).
export const STRIPE_API_VERSION = '2020-08-27';

let stripePromise: Promise<Stripe | null> | undefined;

// One Stripe.js instance for the whole app: the card form and the sagas that act on a
// PaymentIntent outside the form must share it so they see the same API version and options.
// Loaded on first use rather than at import time so tests and non-payment pages do not load Stripe.js.
export const getStripe = (): Promise<Stripe | null> => {
  if (!stripePromise) {
    stripePromise = loadStripe(appConfig.stripe.apiKey, { apiVersion: STRIPE_API_VERSION });
  }
  return stripePromise;
};
